export const sleep = (
  ms: number,
  options?: {
    signal?: AbortSignal;
  },
) => {
  return new Promise((resolve) => {
    const timeout = setTimeout(resolve, ms);

    options?.signal?.addEventListener("abort", () => {
      clearTimeout(timeout);
      resolve(void 0);
    });
  });
};
